export default "__VITE_ASSET__Dxvms1Qt__"